import moment from "moment";

import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { ISelectControlOption, SelectControl } from "@/Common/Components/LinkedAppointmentSelect/SelectControl";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { IPatientEnrollmentModel } from "@/Common/Models/Patient/UI/Profile/IPatientEnrollmentModel";
import { Person } from "@/Common/Models/Person/Person";
import { RAMQDispensateurClass } from "@/Common/Models/RAMQ/enums/RAMQDispensateurClass";
import { RAMQInfo } from "@/Common/Models/RAMQ/RAMQInfo";
import { RAMQInscription } from "@/Common/Models/RAMQ/RAMQInscription";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { IPatientProfileEnrollmentComponentProps } from "./IPatientProfileComponentProps";

class PatientProfileEnrollmentInfoComponent extends React.Component<IPatientProfileEnrollmentComponentProps, any> {
    public render(): JSX.Element {
        var enrolmentModel = this.props.model;
        var ramqInfo: RAMQInscription;

        var availableDispensateurs: Person[] = [];

        if (enrolmentModel) {
            ramqInfo = enrolmentModel.get("RAMQInscription");
            availableDispensateurs = (enrolmentModel.get("AvailableDispensateur")) ? enrolmentModel.get("AvailableDispensateur").toArray() : [];
        }

        var enrollmentJsxList = this.GetEnrollmentRender(ramqInfo, enrolmentModel, this.props.IsInAddMode, this.props.IsInEditMode, availableDispensateurs);

        return (
            <tbody>
                {enrollmentJsxList.map(x => x)}
            </tbody>
        );
    }

    private GetEnrollmentRender(ramqInfo: RAMQInscription, model: IPatientEnrollmentModel, showAdd: boolean = false, showEdit: boolean = false, dispensateurs: Person[]): JSX.Element[] {
        var enrolmentRender: JSX.Element[] = [];

        if (showAdd) {
            enrolmentRender.push(
                <tr key={GuidHelper.NewGuid()}>
                    {cacheStore.ClinicSettings.EnableIpsEnrolmentForRamq
                        ? this.RenderProviderDropdown(dispensateurs, model)
                        : this.RenderProviderDropdownLegacy(dispensateurs, model)
                    }
                </tr>
            );

            enrolmentRender.push(
                <tr key={GuidHelper.NewGuid()}>
                    <td className="c1pad form">
                        <span>{cacheStore.GetString("NoProviderLabel")}</span>
                    </td>
                    <td className="c2">
                        <strong>{MyleHelper.ReplaceEmptyString(model.get("DispensateurNumber"))}</strong>
                    </td>
                </tr>
            );

            enrolmentRender.push(
                <tr key={GuidHelper.NewGuid()}>
                    <td className="c1pad form">
                        <label htmlFor="NoGMF">{cacheStore.GetString("NoGMFLabel")}</label>
                    </td>
                    <td className="c2">
                        <TextboxControl value={model.get("NoGmf")} className="form-control" operation={LocalPatientOperations.Profile.Enrollment_NoGmfChange} />
                    </td>
                </tr>
            );

            enrolmentRender.push(
                <tr key={GuidHelper.NewGuid()}>
                    <td className="c1pad form">
                        <label htmlFor="DateOfEffect">{cacheStore.GetString("DateOfEffectLabel")}</label>
                    </td>
                    <td className="c2">
                        <DateSelector id="datepriseffet" cssClass="auto-width" dateFormat="dddd, MMM dd, yyyy" disabled={false} date={model.get("EnrollmentEffectiveDate")} onSelectOp={LocalPatientOperations.Profile.Enrollment_DatePriseEffetChange} />
                    </td>
                </tr>
            );
        }
        else if (showEdit) {
            enrolmentRender.push(
                <tr key={GuidHelper.NewGuid()}>
                    <td className="c1pad form">
                        <label htmlFor="DateOfEffect">{cacheStore.GetString("DateOfEffectLabel")}</label>
                    </td>
                    <td className="c2">
                        <DateSelector id="datepriseffet" cssClass="auto-width" dateFormat="dddd, MMM dd, yyyy" disabled={false} date={model.get("EnrollmentEffectiveDate")} onSelectOp={LocalPatientOperations.Profile.Enrollment_DatePriseEffetChange} />
                    </td>
                </tr>
            );
        }
        else if (ramqInfo) {
            enrolmentRender.push(
                <tr key={GuidHelper.NewGuid()}>
                    <td className="c1pad form">
                        <span>{cacheStore.ClinicSettings.EnableIpsEnrolmentForRamq ? cacheStore.GetString("NameOrRAMQNumberLabel") : cacheStore.GetString("NameOrLicenceNumberLabel")}</span>
                    </td>
                    <td className="c2">
                        <strong>{MyleHelper.ReplaceEmptyString(RAMQInfo.ResolveProviderName(ramqInfo))}</strong>
                    </td>
                </tr>
            );

            enrolmentRender.push(
                <tr key={GuidHelper.NewGuid()}>
                    <td className="c1pad form">
                        <span>{cacheStore.GetString("ProviderClassLabel")}</span>
                    </td>
                    <td className="c2">
                        <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.DoctorClass)}</strong>
                    </td>
                </tr>
            );

            enrolmentRender.push(
                <tr key={GuidHelper.NewGuid()}>
                    <td className="c1pad form">
                        <span>{cacheStore.GetString("NoProviderLabel")}</span>
                    </td>
                    <td className="c2">
                        <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.DoctorLicence)}</strong>
                    </td>
                </tr>
            );

            enrolmentRender.push(
                <tr key={GuidHelper.NewGuid()}>
                    <td className="c1pad form">
                        <span>{cacheStore.GetString("NoGMFLabel")}</span>
                    </td>
                    <td className="c2">
                        <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.NoGmf)}</strong>
                    </td>
                </tr>
            );

            enrolmentRender.push(
                <tr key={GuidHelper.NewGuid()}>
                    <td className="c1pad form">
                        <span>{cacheStore.GetString("DateOfEffectLabel")}</span>
                    </td>
                    <td className="c2">
                        <strong>{MyleHelper.ReplaceEmptyString(moment(ramqInfo.DatePrisedEffet).format("YYYY-MM-DD hh:mm:ss"))}</strong>
                    </td>
                </tr>
            );
        }
        else {
            enrolmentRender.push((<div />));
        }

        return enrolmentRender;
    }

    private onDispensensateurChange(selectedId: string): void {
        const disp = this.props.model.get("AvailableDispensateur")?.toArray().filter(p => p.ContactFacetId === selectedId).firstOrDefault();
        sessionStore.dispatch(LocalPatientOperations.Profile.Enrollment_DispensateurChange, { value: disp?.ContactFacetId });
    }

    private RenderProviderDropdownLegacy(dispensateurs: Person[], model: IPatientEnrollmentModel): JSX.Element {
        return (
            <>
                <td className="c1pad  form">
                    <span>{cacheStore.GetString("NameOrLicenceNumberLabel")}</span>
                </td>
                <td className="c2">
                    <select onChange={e => this.onDispensensateurChange(e?.target?.value)} className="form-control myle-control" value={model.get("SelectedDispensateurId") ? model.get("SelectedDispensateurId") : ""}>
                        <option value=""> </option>
                        {dispensateurs.map((p: Person) => (
                            <option key={p.ContactFacetId} value={p.ContactFacetId}> {p.Name} ({p.EmployeeModel.FirstLicenceNumber}) </option>
                        ))}
                    </select>
                </td>
            </>
        );
    }

    private RenderProviderDropdown(dispensateurs: Person[], model: IPatientEnrollmentModel): JSX.Element {
        const dispensateursOptions: ISelectControlOption[] = dispensateurs
            .map(person => ({
                value: person.ContactFacetId,
                label: <span>{this.formatProviderAndIpsDropdownOption(person)}</span>,
                filterLabel: this.formatProviderAndIpsDropdownOption(person)
            }));

        return (
            <>
                <td className="c1pad form">
                    <label>{cacheStore.GetString("NameOrRAMQNumberLabel")}</label>
                </td>
                <td className="c2">
                    <SelectControl
                        optionsData={dispensateursOptions || []}
                        value={model.get("SelectedDispensateurId") ? model.get("SelectedDispensateurId") : null}
                        onChangeCallback={value => this.onDispensensateurChange(value)}
                        maxMenuHeight={180}
                        isEllipsis
                        pageSize={50}
                        useEmptyOption
                        showPlaceHolderSearchIcon
                        placeHolderText={cacheStore.GetString("SearchLabel")}
                    />
                </td>
            </>
        );
    }

    private formatProviderAndIpsDropdownOption(person: Person): string {
        const dispClass = RAMQInfo.ResolveDispensableClass(person.EmployeeModel);

        let ramqNumber = "";
        if (dispClass === RAMQDispensateurClass.Doctor) {
            ramqNumber = RAMQInfo.appendRamqCheckSumIfMissing(person.EmployeeModel.FirstLicenceNumber);
        }
        else if (dispClass === RAMQDispensateurClass.IPS && RAMQInfo.ValidateIPSRamqNumber(person.EmployeeModel.RamqNumber)) {
            ramqNumber = RAMQInfo.appendRamqCheckSumIfMissing(person.EmployeeModel.RamqNumber, RAMQDispensateurClass.IPS);
        }

        const formattedLicenceOrRamqNumber = RAMQInfo.SplitAndFormatRamqNumber(ramqNumber);

        return `${person.Name}${formattedLicenceOrRamqNumber ? ` (${formattedLicenceOrRamqNumber})` : ""}`;
    }
}

export { PatientProfileEnrollmentInfoComponent };
